import React, { useState } from "react";
import "./AdminPage.css";

// ✅ Frontend-only password (NOT secure - visible in built JS)
const DEFAULT_PASSWORD = "ADMIN@123"; // change as you like

// ✅ backend access code (still frontend - better put in .env)
const ACCESS_CODE = "CLYRA@2025c";

const AdminPage = () => {
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [data, setData] = useState({ contacts: [], consultations: [] });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    // ✅ 1) Frontend password check only
    if (password !== DEFAULT_PASSWORD) {
      setError("Invalid password");
      return;
    }

    // ✅ 2) Fetch admin data from backend
    try {
      setLoading(true);

      const res = await fetch("https://overseas-backend-1-548y.onrender.com/api/admin-data", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: ACCESS_CODE }),
      });

      const result = await res.json();

      if (!res.ok) throw new Error(result.message || "Access denied");

      setData({
        contacts: result.contacts || [],
        consultations: result.consultations || [],
      });
      setAuthenticated(true);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!authenticated) {
    return (
      <div className="admin-page">
        <div className="admin-login">
          <h2>Admin Login</h2>

          <form onSubmit={handleLogin} className="admin-form">
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Loading..." : "Login"}
            </button>
          </form>

          {error && <p className="error">{error}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="data-tables">
        <h2>📋 Contact Form Submissions ({data.contacts.length})</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Requirement</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {data.contacts.map((contact) => (
              <tr key={contact._id}>
                <td>{contact.name}</td>
                <td>{contact.email}</td>
                <td>{contact.phone}</td>
                <td>{contact.requirement}</td>
                <td>{new Date(contact.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h2>📋 Consultation Form Submissions ({data.consultations.length})</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Country</th>
              <th>Level</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {data.consultations.map((consult) => (
              <tr key={consult._id}>
                <td>{consult.name}</td>
                <td>{consult.email}</td>
                <td>{consult.phone}</td>
                <td>{consult.country}</td>
                <td>{consult.level}</td>
                <td>{new Date(consult.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminPage;
